import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'antd';
import './style.scss';
const AlertMessage = _ref => {
  let {
    message,
    type,
    showIcon
  } = _ref;
  return /*#__PURE__*/React.createElement(Alert, {
    message: message,
    type: type,
    showIcon: showIcon
  });
};
AlertMessage.propTypes = {
  message: PropTypes.string,
  type: PropTypes.string,
  showIcon: PropTypes.bool
};
AlertMessage.defaultProps = {
  message: 'No Cards Found',
  type: 'error',
  showIcon: true
};
export default AlertMessage;